import React from "react";
import { FaLinkedinIn, FaFacebookF, FaEnvelope } from "react-icons/fa";

import Mustafizur from "../../assets/Team/MustafizurRahman.jpeg";
import Saroar from "../../assets/Team/SaroarHossinSagor.jpg";
import BoniAmin from "../../assets/Team/Boni_Amin.jpeg";
import Sanaullah from "../../assets/Team/SanaullahFakir.jpg";
import Mikail from "../../assets/Team/Mikail.jpg";
import Josim from "../../assets/Team/JosimMolla.jpg";
import Sumon from "../../assets/Team/MohammadSumon.jpg";
import mdMamun from "../../assets/Team/MDMamun.png";

import AboutBanner from "./AboutBanner.jsx";
import SisterConcerms from "./SisterConcerms";

const leadershipTeam = [
  {
    name: "Saroar Hossine Sagor",
    role: "Chairman at",
    company: "Iconic Greenland Ltd.",
    imageKey: "team.saroar",
    fallbackImage: Saroar,
    socials: {
      facebook: "#",
      linkedin: "#",
      email: "",
    },
    description:
      "Empowering corporate governance and fostering robust partnerships for long-term business development.",
  },
  {
    name: "Md. Mamun",
    role: "Vice-Chairman at",
    company: "Iconic Greenland Ltd.",
    imageKey: "team.mamun",
    fallbackImage: mdMamun,
    socials: {
      facebook: "#",
      linkedin: "#",
      email: "",
    },
    description:
      "Empowering corporate governance and fostering robust partnerships for long-term business development.",
  },
  {
    name: "Md. Mustafizur Rahman",
    role: "Vice Chairman",
    company: "Iconic Greenland Ltd.",
    imageKey: "team.Mustafizur",
    fallbackImage: Mustafizur,
    socials: {
      facebook: "#",
      linkedin: "#",
      email: "#",
    },
    description:
      "A visionary leader driving the strategic direction and sustainable growth of the entire organization.",
  },
  {
    name: "Boni Amin Fokir",
    role: "Managing Director at",
    company: "Iconic Greenland Ltd.",
    imageKey: "team.boniAmin",
    fallbackImage: BoniAmin,
    socials: {
      facebook: "#",
      linkedin: "#",
      email: "",
    },
    description:
      "Empowering corporate governance and fostering robust partnerships for long-term business development.",
  },
  {
    name: "Md. Sanaullah Fakir",
    role: "DMD at",
    company: "Iconic Greenland Ltd.",
    imageKey: "team.sanaullah",
    fallbackImage: Sanaullah,
    socials: {
      facebook: "#",
      linkedin: "#",
      email: "",
    },
    description:
      "Empowering corporate governance and fostering robust partnerships for long-term business development.",
  },
  {
    name: "Md. Mikail",
    role: "Finance Director at",
    company: "Iconic Greenland Ltd.",
    imageKey: "team.mikail",
    fallbackImage: Mikail,
    socials: {
      facebook: "#",
      linkedin: "#",
      email: "",
    },
    description:
      "Empowering corporate governance and fostering robust partnerships for long-term business development.",
  },
  {
    name: "Md. Josim Molla",
    role: "Project Director & CEO at",
    company: "Iconic Greenland Ltd.",
    imageKey: "team.saroar",
    fallbackImage: Josim,
    socials: {
      facebook: "#",
      linkedin: "#",
      email: "",
    },
    description:
      "Empowering corporate governance and fostering robust partnerships for long-term business development.",
  },
  {
    name: "Muhammad Sumon",
    role: "Sales & Marketing Director at",
    company: "Iconic Greenland Ltd.",
    imageKey: "team.sumon",
    fallbackImage: Sumon,
    socials: {
      facebook: "#",
      linkedin: "#",
      email: "",
    },
    description:
      "Empowering corporate governance and fostering robust partnerships for long-term business development.",
  },
];

const OurManagementBoard = () => {
  const currentLeadershipTeam = leadershipTeam.map((m) => ({
    ...m,
    image: null,
  }));

  return (
    <div className="bg-white">
      {/* Banner Section */}
      <AboutBanner
        title="All Directors"
        description="The visionary leaders driving Iconic Global Travels Ltd and its concerns toward sustainable growth and excellence."
      />

      {/* Leadership Team Grid */}
      <section>
        <div className="container py-2">
          {/* <div className="text-center max-w-3xl mx-auto mb-5">
            <span className="text-info text-uppercase fw-bold tracking-wider small">
              Visionary Leadership
            </span>
            <h2 className="display-6 fw-bold text-dark mt-2">
              MEET OUR{" "}
              <span style={{ color: "#BD06D3" }}>MANAGEMENT BOARD</span>
            </h2>
            <p className="text-muted fs-5">
              Combining enterprise experience with strategic vision to lead
              Iconic Unity Group and its concerns to new heights.
            </p>
          </div> */}

          <div className="row g-4 justify-content-center">
            {currentLeadershipTeam.map((member, index) => {
              const fallback = leadershipTeam[index];
              const displayImage = member.fallbackImage;

              return (
                <div className="col-xl-3 col-lg-4 col-md-6" key={index}>
                  <div className="card border-0 shadow-sm rounded-4 overflow-hidden h-100 bg-white hover-top transition position-relative">
                    {/* Image Wrapper */}
                    <div
                      className="position-relative overflow-hidden bg-light"
                      style={{ height: "320px" }}
                    >
                      <img
                        src={displayImage}
                        alt={member.name}
                        className="w-100 h-100 object-fit-cover"
                      />

                      {/* Hover Overlay with Social Links */}
                      <div className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center gap-3 bg-dark bg-opacity-25 opacity-0 hover-opacity transition">
                        {member.socials?.facebook && (
                          <a
                            href={member.socials.facebook}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-light rounded-circle p-2 d-flex align-items-center justify-content-center shadow"
                            style={{ width: "40px", height: "40px" }}
                          >
                            <FaFacebookF className="text-primary" size={18} />
                          </a>
                        )}
                        {member.socials?.linkedin && (
                          <a
                            href={member.socials.linkedin}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-light rounded-circle p-2 d-flex align-items-center justify-content-center shadow"
                            style={{ width: "40px", height: "40px" }}
                          >
                            <FaLinkedinIn className="text-info" size={18} />
                          </a>
                        )}
                        {member.socials?.email && (
                          <a
                            href={member.socials.email}
                            className="btn btn-light rounded-circle p-2 d-flex align-items-center justify-content-center shadow"
                            style={{ width: "40px", height: "40px" }}
                          >
                            <FaEnvelope
                              style={{ color: "#BD06D3" }}
                              size={18}
                            />
                          </a>
                        )}
                      </div>
                    </div>

                    {/* Member Info Body */}
                    <div className="card-body p-4 text-center d-flex flex-column">
                      <h4 className="fw-bold text-dark mb-1 h5">
                        {member.name}
                      </h4>

                      <div className="mb-3">
                        <span
                          className="fw-bold d-block small"
                          style={{ color: "#BD06D3" }}
                        >
                          {member.role}
                        </span>
                        {fallback?.company && (
                          <small className="text-muted d-block">
                            {fallback.company}
                          </small>
                        )}
                      </div>

                      <p className="text-muted small leading-relaxed mb-0 flex-grow-1">
                        {member.description || fallback?.description}
                      </p>
                    </div>

                    {/* Bottom Border Accent */}
                    <div
                      className="w-100"
                      style={{ height: "3px", backgroundColor: "#BD06D3" }}
                    />
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Sister Concerns Component */}
      <div className="py-4">
        <SisterConcerms />
      </div>
    </div>
  );
};

export default OurManagementBoard;
